import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './routes/Home';
import FreeTools from './routes/FreeTools';
import ProtectedAdminRoute from './ProtectedAdminRoute';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/tools/:toolName" element={<FreeTools />} />
        <Route path="/admin" element={<ProtectedAdminRoute />} />
      </Routes>
    </Router>
  );
};

export default App;
